<template>
	<el-dialog title="更换详情信息" v-model="isDetail" width="80%" center :close-on-click-modal="false"
		@closed="dialogClosedHandle">
		<div class="page_warp">
			<div style="height: 200px;">
				<div class="rpt_tit">
					<p class="platTitle">基本信息</p>
				</div>
				<div class="info-input-container">
					<div class="flex flex-y-center flex-wrap">
						<div class="w30 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>车牌号码：</span>
							</div>
							<span class="platItemRigth">{{vemrVehNo}}</span>
						</div>
						<div class="w30 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>轮胎规格：</span>
							</div>
							<span class="platItemRigth"></span>
						</div>
						<div class="w30 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>总更换条数：</span>
							</div>
							<span class="platItemRigth">{{sumQuantity}}</span>
						</div>
						<div class="w30 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>更换次数：</span>
							</div>
							<span class="platItemRigth">{{sumCount}}</span>
						</div>
						<div class="w30 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>更换里程周期：</span>
							</div>
							<span class="platItemRigth">{{vempMilesInterval}}</span>
						</div>
						<div class="w30 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>提前提醒里程：</span>
							</div>
							<span class="platItemRigth">{{vempMilesAdvance}}</span>
						</div>
						<div class="w30 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>更换时间周期：</span>
							</div>
							<span class="platItemRigth">{{vempDateInterval}}</span>
						</div>
						<div class="w30 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span class="input-fail">*</span>
								<span>提前提醒时间：</span>
							</div>
							<span class="platItemRigth">{{vempDateAdvance}}</span>
						</div>
						<div class="w30 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>距下次更换：</span>
							</div>
							<span class="platItemRigth">{{remainDay}}天</span>
						</div>
						<div class="w30 flex flex-y-center platItem">
							<div class="flex flex-y-center platItemLeft">
								<span>当前状态：</span>
							</div>
							<span class="platItemRigth" style="color: #00aa00;" v-if="expireDateStatus==='0'">正常</span>
							<span class="platItemRigth" style="color: #0000ff;"
								v-else-if="expireDateStatus==='1'">快到期</span>
							<span class="platItemRigth" style="color: #ff0000;" v-else>过期</span>
						</div>
					</div>
				</div>
			</div>
			<div class="flex">
				<div class="rpt_tit">
					<p class="platTitle">更换记录
					</p>
				</div>
			</div>
			<div class="bottom_content">
				<div class="table_container" v-bind:id="tableId">
					<el-table v-bind:data="tableData" stripe border style="width: 100%" v-bind:max-height="300"
						v-bind:header-cell-style="{
						  textAlign: 'center',
						  color: '#333333',
						  background: '#F5F5F5',
						}" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据">
						<el-table-column type="index" label="序号" width="120"></el-table-column>
						<el-table-column prop="itemList[0].vemiBrand" label="轮胎品牌" width="120"></el-table-column>
						<el-table-column prop="itemList[0].vemiSpecifications" label="轮胎规格" width="120"></el-table-column>
						<el-table-column prop="itemList[0].vemiCount" label="更换数量(条)" width="120"></el-table-column>
						<el-table-column prop="vemrMoney" label="总金额(元)" width="120"></el-table-column>
						<el-table-column prop="vemrUpdateDate" label="更换日期" width="120">
						</el-table-column>
						<el-table-column prop="vemrUpdateMiles" label="更换时里程(公里)" width="140">
						</el-table-column>
						<el-table-column prop="vemrDescribe" label="更换原因" width="120">
						</el-table-column>
						<el-table-column prop="vemrCreator" label="更换经办人" width="120"></el-table-column>
						<el-table-column prop="vemrPayStatus" label="支付状态" width="120">
							<template #default="scope">
								<span v-if="scope.row.vemrPayStatus == '0'">未支付</span>
								<span v-else-if="scope.row.vemrPayStatus == '1'">已支付</span>
								<span v-else>--</span>
							</template>
						</el-table-column>
						<el-table-column prop="vemrPayDate" label="支付日期" width="120"></el-table-column>
						<el-table-column prop="vemrPayAccount" label="支付账户" width="120"></el-table-column>
						<el-table-column prop="vemrModtime" label="更新时间" width="120"></el-table-column>
						<el-table-column label="操作" fixed="right" width="140">
							<template #default="scope">
								<span class="default_color pointer m-right10"
									v-on:click="editRecord(scope.row.vemrId)">编辑</span>
								<span class="default_color pointer m-right10"
									v-on:click="detailRecord(scope.row.vemrId)">详情</span>
								<span class="col-FF1A1A pointer" v-on:click="del(scope.row.vemrId)">删除</span>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="flex flex-y-center flex-x-center m-top20">
					<el-config-provider :locale="locale">
						<el-pagination background v-model:currentPage="page" v-model:page-size="pageSize"
							:page-sizes="[5, 10, 15, 20]" layout="sizes, prev, pager, next, total, jumper"
							:total="totalCount" @size-change="getData" @current-change="getData" />
					</el-config-provider>
				</div>
			</div>

			<DetailRecord ref="detailRecordRef" v-if="isDetailRecord" @getData="getData" />
			<EditRecord ref="editRecordRef" v-if="isEditRecord" @getData="getData" />
		</div>
	</el-dialog>
</template>

<script>
	import {
		defineComponent,
		reactive,
		toRefs,
		computed,
		getCurrentInstance,
		onMounted,
		nextTick,
	} from "vue";
	import {
		imgFileToBase64,
		isPhone,
		isIdNo
	} from "@/libs/tools";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	import DetailRecord from "./detailRecord";
	import EditRecord from "./editRecord";
	export default defineComponent({
		components: {
			DetailRecord,
			EditRecord
		},
		name: "Detail",
		// emits: ["getData"],

		setup(props, context) {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			// const getData = () => {
			// 	context.emit("getData");
			// };


			const data = reactive({
				tableId: "roleManagementTable",
				isDetail: false,
				isDetailRecord: false,
				isEditRecord: false,
				searchWord: "",
				index: 0,
				page: 1,
				pageSize: 10,
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				olseDefedit: false,
				olseDefeditisReadOnly: true,

				vempId: "",
				vempVehId: "",
				vemrVehNo: "",
				vempLastDate: "",
				vempLastMiles: "",
				vempDateInterval: "",
				vempDateAdvance: "",
				vempMilesInterval: "",
				vempMilesAdvance: "",
				vempRemark: "",
				remainMiles: null,
				remainDay: null,
				expireDateStatus: "0", //时间到期状态：0未到期，1临期，2过期
				expireMilesStatus: null, //里程到期状态：0未到期，1临期，2过期
				sumCount: 0,
				sumMoney: 0,
				sumQuantity: 0,
				vempStatus: "0",

				permissionItem: {
					list: false,
					del: false,
					set: false,
					export: false,
				},

			});

			onMounted(() => {
				let perms = proxy.$storage.get("perms");
				perms.forEach((el) => {
					if (el == "lineManage:list") {
						data.permissionItem.list = true;
					}
					if (el == "lineManage:del") {
						data.permissionItem.del = true;
					}
					if (el == "lineManage:set") {
						data.permissionItem.set = true;
					}
					if (el == "lineManage:export") {
						data.permissionItem.export = true;
					}
				});

				nextTick(() => {
					data.tableHeight =
						document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight - 40;

				});
				window.onresize = () => {
					nextTick(() => {
						var offsetHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
						if (offsetHeight <= 0) {
							return false;
						}
						data.tableHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
					});
				};
			});

			//重置数据
			const init = async (id,VehId) => {
				data.isDetail = true;
				data.vempId = id;
				data.vempVehId = VehId;
				data.vemrVehNo = "";
				data.vempLastDate = "";
				data.vempLastMiles = "";
				data.vempDateInterval = "";
				data.vempDateAdvance = "";
				data.vempMilesInterval = "";
				data.vempMilesAdvance = "";
				data.vempRemark = "";
				data.remainMiles = null;
				data.expireDateStatus = null;
				data.expireMilesStatus = null;
				data.remainDay = null;
				data.sumCount = 0;
				data.sumMoney = 0;
				data.sumQuantity = 0;
				data.vempStatus = "0";

				getMainData();
				getData();

			};

			//获取列表数据
			const getMainData = async () => {
				let params = {
					vempId: data.vempId,
				};
				const r = await proxy.$http.get(apiObj.vehMaintenanceProdedit, params);
				if (r.code === 0 || r.respCode === '0000') {
					data.vempVehId = r.vehMaintenanceProd.vempVehId;
					data.vemrVehNo = r.vehMaintenanceProd.vehNo;
					data.vempLastDate = r.vehMaintenanceProd.vempLastDate;
					data.vempLastMiles = r.vehMaintenanceProd.vempLastMiles;
					data.vempDateInterval = r.vehMaintenanceProd.vempDateInterval;
					data.vempDateAdvance = r.vehMaintenanceProd.vempDateAdvance;
					data.vempMilesInterval = r.vehMaintenanceProd.vempMilesInterval;
					data.vempMilesAdvance = r.vehMaintenanceProd.vempMilesAdvance;
					data.vempRemark = r.vehMaintenanceProd.vempRemark;
					data.remainMiles = r.vehMaintenanceProd.remainMiles;
					data.remainDay = r.vehMaintenanceProd.remainDay;
					data.expireDateStatus = r.vehMaintenanceProd.expireDateStatus;
					data.expireMilesStatus = r.vehMaintenanceProd.expireMilesStatus;
					data.sumCount = r.vehMaintenanceProd.sumCount;
					data.sumMoney = r.vehMaintenanceProd.sumMoney;
					data.sumQuantity = r.vehMaintenanceProd.sumQuantity;
					data.vempStatus = r.vehMaintenanceProd.vempStatus;

				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};

			//获取列表数据
			const getData = async () => {
				let params = {
					searchWord: data.searchWord,
					page: data.page,
					limit: data.pageSize,
					vemrType: '0',
					vemrVehId: data.vempVehId,
					vehNo: '',
					vehOrg: '',
					expireDateStatus: '',
				};
				const r = await proxy.$http.get(apiObj.vehMaintenanceReclist, params);
				if (r.code === 0 || r.respCode === '0000') {
					data.tableData = r.rows;
					data.totalCount = r.total;
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};


			const navClick = (index) => {
				data.index = index;
			};

			const dialogClosedHandle = () => {
				data.isDetail = false;
			};
			const closeModal = () => {
				data.isDetail = false;
			};

			const timeDeltaCount = function(time) {
				if (time) {
					var s = time % 60;
					var m = Math.floor(time / 60) % 60;
					var h = Math.floor(Math.floor(time / 60) / 60);

					if (h !== 0) {
						return h + "小时" + m + "分";
					}
					if (m !== 0) {
						return m + "分";
					}
					return s + "秒";
				} else {
					return ''
				}
			};

			const olseDefeditChange = (value) => {
				data.olseDefedit = value;
				data.olseDefeditisReadOnly = !value;

			};

			//编辑线路标准参数
			const olseDefeditsave = async () => {
				if (!data.permissionItem.set) {
					proxy.$message.error("没有线路标准设置权限！");
					return;
				}

				if (data.olseDefDuration == "" || data.olseDefDuration == null) {
					proxy.$message.error("请填写标准耗时");
					return;
				}
				if (data.olseDefMilage == "" || data.olseDefMilage == null) {
					proxy.$message.error("请填写标准里程");
					return;
				}
				if (data.olseDefGas == "" || data.olseDefGas == null) {
					proxy.$message.error("请填写标准气耗");
					return;
				}
				if (data.olseDefFuel == "" || data.olseDefFuel == null) {
					proxy.$message.error("请填写标准油耗");
					return;
				}
				if (data.olseDefTollCost == "" || data.olseDefTollCost == null) {
					proxy.$message.error("请填写标准路桥费");
					return;
				}
				if (data.olseDefFreewayCost == "" || data.olseDefFreewayCost == null) {
					proxy.$message.error("请填写标准高速费");
					return;
				}

				let params = {
					olseRecNo: data.lineId,
					olseDefDuration: data.olseDefDuration, //标准耗时
					olseDefMilage: data.olseDefMilage, //标准里程
					olseDefGas: data.olseDefGas, //标准气耗
					olseDefFuel: data.olseDefFuel, //标准油耗
					olseDefElectricity: 0, //标准电耗
					olseDefTollCost: data.olseDefTollCost, //标准路桥费
					olseDefFreewayCost: data.olseDefFreewayCost, //标准高速费
				};

				const r = await proxy.$http.post(apiObj.LineSetupdate, params)
				if (r.code === 0 || r.respCode === '0000') {
					proxy.$message.success(r.msg || r.respMsg);
					init(data.lineId);
				} else {
					proxy.$message.error(r.msg || r.respMsg);
				}
			};

			// 菜单详情
			const detailRecord = (id) => {

				data.isDetailRecord = true;
				nextTick(() => {
					proxy.$refs.detailRecordRef.init(id);
				});
			};

			// 菜单编辑
			const editRecord = (id) => {

				data.isEditRecord = true;
				nextTick(() => {
					proxy.$refs.editRecordRef.init(id);
				});
			};

			//菜单删除
			const del = (id) => {
				proxy
					.$confirm("您确定删除选中的数据吗", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning",
					})
					.then(async () => {
						let params = {
							vemrId: id,
						};
						const r = await proxy.$http.postFormData(apiObj.vehMaintenanceRecremove,
							params);
						if (r.respCode == 0 || r.respCode == "0000") {
							proxy.$message.success(r.msg || r.respMsg);
							getData();
						} else {
							proxy.$message.error(r.msg || r.respMsg);
						}
					});
			};

			return {
				...toRefs(data),
				init,
				closeModal,
				dialogClosedHandle,
				getData,
				navClick,
				timeDeltaCount,
				olseDefeditChange,
				olseDefeditsave,
				detailRecord,
				editRecord,
				del,
			};
		},
	});
</script>

<style scoped>
	.page_warp {
		width: 100%;
		height: 600px;
	}

	.top_content {
		width: 100%;
		height: 70px;
		padding: 0 25px;
		margin-bottom: 10px;
		background: #ffffff;
		display: flex;
		align-items: center;
		justify-content: center;
		box-sizing: border-box;
	}

	.bottom_content {
		width: 100%;
		height: calc(100% - 210px);
		background: #ffffff;
	}

	.bottom_content .table_container {
		width: calc(100% - 50px);
		height: calc(100% - 80px);
		margin: 0 auto;
		padding-top: 0px;
	}

	.nav_warp {
		width: 100%;
		height: 60px;
		background: #ffffff;
		border-bottom: 1px solid #eeeeee;
		display: flex;
		align-items: center;
	}

	.nav_item {
		position: relative;
		height: 78px;
		padding: 0 20px;
		margin-left: 50px;
		cursor: pointer;
	}

	.nav_item span {
		font-size: 18px;
		color: #666666;
		line-height: 78px;
	}

	.nav_item_ac span {
		color: #293787 !important;
	}

	.nav_item_line {
		position: absolute;
		width: 90%;
		left: 5%;
		height: 3px;
		background: #293787;
		bottom: 5px;
	}

	.input_row {
		width: 100%;
		height: 50px;
		display: flex;
		align-items: center;
	}

	.input_lable {
		width: 80px;
		text-align: right;
	}

	.input_box {
		width: 50%;
	}

	.input_tree_warp {
		width: calc(100% - 30px);
		height: 300px;
		margin-left: 30px;

		box-sizing: border-box;
		margin-top: 10px;
		display: flex;
		justify-content: space-between;
	}

	.manage {
		width: 48%;
		height: 100%;

		display: flex;
	}

	.tree {
		width: calc(100% - 80px);
		height: 100%;
		overflow: auto;
	}

	.footer_btn_warp {
		width: 100%;
		height: 70px;
		margin-top: 30px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.cancle_btn {
		width: 116px;
		height: 38px;
		background: #e36a19;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
		margin-right: 90px;
	}

	.confirm_btn {
		width: 116px;
		height: 38px;
		background: #293787;
		border-radius: 4px;
		text-align: center;
		color: #fff;
		font-size: 14px;
		line-height: 38px;
		cursor: pointer;
	}

	.platTitle {
		line-height: 20px;
		font-size: 15px;
		color: #000;
		font-weight: 600;
		position: relative;
		padding-left: 20px;
		padding-bottom: 10px;
	}

	.platTitle::before {
		content: "";
		width: 4px;
		height: 18px;
		background: #20ca68;
		border-radius: 2px;
		position: absolute;
		top: 0px;
		left: 10px;
	}

	.platItem {
		margin-bottom: 20px;
	}

	.platItemLeft {
		min-width: 110px;
		justify-content: flex-start;
	}

	.platItem input {
		width: 80%;
		height: 38px;
		border: 1px solid #ededed;
		border-radius: 4px;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth {
		width: 80%;
		padding-left: 20px;
		box-sizing: border-box;
	}

	.platItemRigth img {
		width: 190px;
		height: 130px;
	}

	.dialog-footer {
		width: 100%;
		height: 70px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.btn {
		padding: 5px 15px;
		font-size: 14px;
		border-radius: 5px;
		cursor: pointer;
	}

	.rpt_tit {
		width: 100%;
		height: 30px;
		text-align: left;
		font-weight: bold;
		line-height: 70px;
		font-size: 18px;
		color: #333333;
		text-indent: 0px;
		padding-bottom: 10px;
	}

	.editimg {
		width: 200px;
		display: flex;
		align-items: center;
		justify-content: center;
		position: relative;
		margin-right: 10px;
		cursor: pointer;
		color: blue;
	}

	.editimg img {
		width: 14px;
		height: 15px;
		margin-right: 8px;
	}

	.auditwait {
		width: 35px;
		height: 16px;
		background: #0000ff;
		border-radius: 4px;
		text-align: center;
		line-height: 16px;
		font-size: 18px;
		color: #fff;
		padding: 0 5px;
		margin-left: 20px;
	}
</style>